import React, { useState } from "react";

import { shareInviteLink } from "./shareInviteLink";


export default function ChatRoomInvite({
  open,
  roomTitle,
  inviteData,
  onClose,
  onGenerate,
  onRevoke,
}) {
  const [status, setStatus] = useState("");
  const inviteLink = String(inviteData?.invite_link || "").trim();

  if (!open) return null;

  async function handleShare() {
    try {
      let link = inviteLink;
      if (!inviteLink) {
        const generated = await onGenerate?.();
        link = String(generated?.invite_link || "").trim();
      }
      link = String((inviteData?.invite_link || link) || "").trim();
      if (!link) {
        setStatus("Gere um convite antes de compartilhar.");
        return;
      }
      await shareInviteLink({ inviteLink: link, roomTitle });
      setStatus("Convite compartilhado.");
    } catch (error) {
      setStatus("Nao foi possivel compartilhar agora.");
    }
  }

  async function handleCopy() {
    try {
      const link = String(inviteLink || "").trim();
      if (!link) {
        const generated = await onGenerate?.();
        const fallbackLink = String(generated?.invite_link || "").trim();
        if (!fallbackLink) {
          setStatus("Gere um convite antes de copiar.");
          return;
        }
        await navigator.clipboard.writeText(fallbackLink);
        setStatus("Link copiado.");
        return;
      }
      await navigator.clipboard.writeText(link);
      setStatus("Link copiado.");
    } catch {
      setStatus("Falha ao copiar o link.");
    }
  }

  return (
    <div className="vh-chatrooms-modal-backdrop" role="dialog" aria-modal="true">
      <div className="vh-chatrooms-modal">
        <div className="vh-chatrooms-modal-header">
          <div>
            <div className="vh-chatrooms-modal-eyebrow">Convite</div>
            <h2>Compartilhar sala</h2>
          </div>
          <button type="button" className="vh-chatrooms-ghost-btn" onClick={onClose}>
            Fechar
          </button>
        </div>
        <div className="vh-chatrooms-invite-box">
          <div className="vh-chatrooms-section-label">{roomTitle || "Sala"}</div>
          <textarea
            className="vh-chatrooms-invite-textarea"
            readOnly
            value={inviteLink}
            placeholder="Gere um link para compartilhar."
          />
          <div className="vh-chatrooms-invite-meta">
            <span>Expira em: {inviteData?.expires_at || "-"}</span>
            <span>Usos: {inviteData?.max_uses || "-"}</span>
          </div>
        </div>
        <div className="vh-chatrooms-inline-actions">
          <button type="button" className="vh-chatrooms-primary-btn" onClick={onGenerate}>
            Gerar novo link
          </button>
          <button type="button" className="vh-chatrooms-secondary-btn" onClick={handleShare}>
            Compartilhar convite
          </button>
          <button type="button" className="vh-chatrooms-secondary-btn" onClick={handleCopy}>
            Copiar link
          </button>
          <button type="button" className="vh-chatrooms-ghost-btn" onClick={onRevoke}>
            Revogar todos
          </button>
        </div>
        {status ? <div className="vh-chatrooms-inline-status">{status}</div> : null}
      </div>
    </div>
  );
}
